// src/services/firebase.js
// ------------------------------------------------------------
// SETUP: Replace the firebaseConfig object with your own
// Firebase project credentials from:
// https://console.firebase.google.com → Project Settings → Your Apps
// ------------------------------------------------------------

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDHJ2vTgj0jAvfO2xjqUB-twFHxr0hYQVU",
  authDomain: "ytcommentanalyze-test.firebaseapp.com",
  projectId: "ytcommentanalyze-test",
  storageBucket: "ytcommentanalyze-test.firebasestorage.app",
  messagingSenderId: "136422315100",
  appId: "1:136422315100:web:087d1b661f3d373ca14299",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

export default app;